import React, { useState, useContext } from "react";
// import ChildDetail from './ChildDetail';
import moment from "moment";
import DocContext from "./Context/DocContext";
import DocumentList from "./DocumentList";
import ChildInboxMenu from "./ChildInboxMenu";
import DatePicker from "../shared/Datepicker";
import DocumentListItemView from "./DocumentListItemView";
import ComposeMessage from "./ComposeMessage";
// import { SPONSOR_LETTER, CHILD_LETTER } from "../../Constants/childLetter";

const DocumentBody = () => {
    const { store, clearMessage } = useContext(DocContext);
    const [compose, toggleCompose] = useState(false);
    const { selectedMessage, child, code, messageContent } = store;
    const [daterange, setDaterange] = useState(null);

    if (!child.child_id) return "";

    const handleBackClick = () => {
        clearMessage();
    };

    const handleComposeClick = () => {
        toggleCompose(!compose);
    };

    function creatNewLetterButton() {
        // if (code === SPONSOR_LETTER.code || code === CHILD_LETTER.code) {
        return (
            <button
                href="#"
                title="compose a new message"
                className="btn-link button new-message"
                onClick={handleComposeClick}
            >
                <i className="fas fa-plus-circle" /> compose
            </button>
        );
        // }
    }

    function renderDatePicker() {
        if (!store.code) return;

        return (
            <>
                <DatePicker setDate={setDaterange} daterange={daterange} />{" "}
                <button
                    className="date-btn date-reset"
                    onClick={() => setDaterange(null)}
                >
                    <i className="fas fa-ban" /> Reset
                </button>
            </>
        );
    }

    return (
        <div className="document-body">
            {/* {child.photo && <ChildDetail child={child}/>} */}

            <div className="row p-relative">
                {compose && <ComposeMessage click={handleComposeClick} />}

                <div className="columns col-md-4 no-padding">
                    <ChildInboxMenu />
                </div>

                <div className="columns col-md-8">
                    <div className="list-view">
                        {messageContent && (
                            <DocumentListItemView
                                selected={selectedMessage}
                                item={messageContent}
                                click={handleBackClick}
                            />
                        )}

                        <div className="col-md-4">
                            {store.code && creatNewLetterButton()}
                        </div>

                        <div className="date-filter col-md-8">
                            {daterange && (
                                <span className="date-box">
                                    {moment(daterange.start).format(
                                        "MMM D, YYYY"
                                    ) +
                                        " - " +
                                        moment(daterange.end).format(
                                            "MMM D, YYYY"
                                        )}
                                </span>
                            )}{" "}
                            {renderDatePicker()}
                        </div>

                        <div className="clearfix mb-2" />

                        {code && (
                            <DocumentList
                                child={child}
                                type={code}
                                daterange={daterange}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentBody;
